import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 1920 1920",
  "content": "<symbol viewBox=\"0 0 1920 1920\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check\"><g id=\"icon-check_SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"icon-check_SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"icon-check_SVGRepo_iconCarrier\"> <path d=\"M1743.858 267.012 710.747 1300.124 176.005 765.382 0 941.387l710.747 710.871 1209.24-1209.116z\" fill-rule=\"evenodd\" /> </g></symbol>"
});
var result = sprite.add(symbol);
export default symbol